export const theme = {
  themeBase: {
    divWidth: "100%",
    divPadding: "30px",
    divMargin: "0 0 30px 0",
    modalFontWeight: "600"
  },
};

